import { NetworkService } from "./NetworkService";


export class IndicatorServices {
  static async renderSideBar() {
    try {
      const response = await NetworkService.request({
        url: "indicators/list",
        method: "GET",
      });
      return this.prefilter(response);
    } catch (e) {
      return e
    }
  }

  static prefilter(response) {
    const uniqueDimensions = [...new Set(response.map(obj => obj["dimension"]))];
    const groupedData = {};
    uniqueDimensions.forEach(dimension => {
      const objects = response.filter(obj => obj["dimension"] === dimension);
      groupedData[dimension] = objects;
    });
    return groupedData;
  }
}

